import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Link } from 'react-router-dom'
import { Queries, Mutations } from '../../../../graphql'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select, Radio, DatePicker, Avatar, Modal, InputNumber, TimePicker } from 'antd'
import Container from '../../../../components/user/Container'
import FromInput from '../../../../components/user/from/Input'
import { numberWithCommas } from '../../../../utils/number'
import { checkMoreThanLess, changeFormatdate, getTimeFromMins, changeFormatdateThai } from '../../../../utils/formatdate'
import moment from 'moment'
import { NIL } from 'uuid'
import ModalConfirmForm from '../../../../components/user/ModalConfirmForm'
import { alertMessage } from '../../../../utils/message'
import { timeLeave, checkNameApproves } from '../../../../utils/leave'
import { profileObjectKey, employeeDetailObjectKey } from '../../../../utils/auth'
import { checkLinkURL } from '../../../../utils/auth'

import ComponetsRemarkText from '../Components/remarkText'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;
const { TextArea } = Input;

const DOCUMENT_TYPE = [
    { label: 'ใบรับรองแพทย์', value: 'ใบรับรองแพทย์' },
   //  { label: 'ใบสูติบัตร', value: 'ใบสูติบัตร' },
    { label: 'อื่น ๆ', value: 'อื่น ๆ' },
]

const newsDataProfile = '';
const format = 'HH:mm';

class Withdraw extends Component {
	state = {
		loading:false,
      loadingFullpage: true,
      manualLeave: [],
      remarkText: []
	}

   fetchMasterConfigTypeLeave = async () =>{
      const { client, location, match } = this.props

      const { data, errors } = await client.query({
         query: Queries.fetchMasterConfigTypeLeave,
      })
      if(data.fetchMasterConfigTypeLeave){
         let manualLeave = data.fetchMasterConfigTypeLeave.filter(valuesArray => valuesArray.configType == "ManualApprover" || valuesArray.configType == "Manual")
         let remarkText = data.fetchMasterConfigTypeLeave.filter(valuesArray => valuesArray.configType == "Remark")
         console.log('fetchMasterConfigTypeLeave', manualLeave)

         await this.setState({
            remarkText: remarkText ? remarkText[0].configValue1 : null,
            manualLeave,
            loadingFullpage: false
         })
      }else{
         await this.setState({
            loadingFullpage: false
         })
      }
   }

	async componentDidMount(){

      await Promise.all(
         [
            this.fetchMasterConfigTypeLeave()
         ]
      )
    }

	render() {
		const { match } = this.props
        const { getFieldDecorator } = this.props.form
        const { 
            loadingFullpage,
            remarkText,
            manualLeave,
        } = this.state

        console.log('remarkText',remarkText)

		return (
            <Container match={match}>
                <div className="breadcrumb-custom pb-3 mb-5">
                    {/* <Breadcrumb.Item> */}
                        <span style={{ fontSize:"18px" }}>การลา / คู่มือการใช้งาน </span>
                    {/* </Breadcrumb.Item> */}
                </div>

              
                     <Spin spinning={loadingFullpage} delay={500}>
                        <div className="card-container h-100" id="page-profile">
                           <div className="px-5 pt-1 pb-4 card-bg-green">
                              <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white" >
                                 {
                                    manualLeave.length > 0 &&
                                    <Col xs={24} md={24}  className="" >
                                       <p>คู่มือการใช้งาน</p>
                                       <ol className="pl-3">
                                          {
                                                manualLeave.map((values, keys)=>{
                                                if(values.typeValue == 'file'){
                                                   return <li className="mb-2">
                                                            <a style={{ textDecoration:"underline" }} href={ checkLinkURL()+values.configValue2 } target="_blank">{ values.configValue1 }</a>
                                                         </li>
                                                }else if(values.typeValue == 'link'){
                                                   return <li className="mb-2">
                                                            <a style={{ textDecoration:"underline" }} href={ values.configValue2 } target="_blank">{ values.configValue1 }</a>
                                                         </li>
                                                }
                                             })
                                          }
                                       </ol>
                                    </Col>
                                 }
                                 
                                 {/* {
                                    remarkText.length > 1&&
                                    <Col xs={24} md={24}  className="" >
                                       <ComponetsRemarkText remarkText={remarkText}/>
                                    </Col>
                                 } */}
                                
                              </Row>
                           </div>
                        </div>
                     </Spin>
                
                
            </Container>
		)
	}
}

Withdraw.defaultProps = {
	autoFocus: false
}

Withdraw.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedWithdraw = Form.create()(Withdraw)

export default withApollo(WrappedWithdraw)